import { FC } from 'react';
import { SalesReports } from 'components/SalesReports';
import { Page } from 'layouts/Page';
import { ENavigateNames } from '../../routes/constants';

export const SalesReportsPage: FC = () => {
	return (
		<Page title={`${ENavigateNames.SALES_REPORTS}– EAS Control Center`}>
			<SalesReports />
		</Page>
	);
};
